import React from 'react';
import { ButtonHTMLAttributes, ReactNode } from 'react';
import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  secondary?: boolean;
  size?: 'small' | 'medium' | 'large' | undefined;
  disabled?: boolean;
  className?: string;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | undefined;
}

interface BaseButtonProps extends ButtonProps {
  issecondary?: number;
}

const BaseButton = styled(MuiButton)<BaseButtonProps>`
  height: 40px;
  width: 80px;
  font-size: 14px;
  font-weight: 700;
  text-transform: none;
  color: var(--color-primary-button);
  background-color: var(--background-primary-button);
  border-color: var(--background-primary-button);
  stroke: var(--color-primary-button);
  :focus {
    box-shadow: none !important;
    color: var(--color-primary-button);
    background-color: var(--background-primary-button);
    border-color: var(--background-primary-button);
    stroke: var(--color-primary-button);
    outline: var(--outline-button);
  }
  :hover {
    color: var(--color-primary-button-hover);
    background-color: var(--background-primary-button-hover);
    border-color: var(--background-primary-button-hover);
    stroke: var(--color-primary-button-hover);
  }
  :active {
    color: var(--color-primary-button-active);
    background-color: var(--background-primary-button-active);
    border-color: var(--background-primary-button-active);
    stroke: var(--color-primary-button-active);
  }
  :disabled {
    color: var(--color-primary-button-disabled);
    background-color: var(--background-primary-button-disabled);
    border-color: var(--background-primary-button-disabled);
  }

  ${({ issecondary: secondary }) =>
    secondary &&
    `
    color: var(--color-secondary-button);
    background-color: var(--background-secondary-button);
    border-color: var(--background-secondary-button);
    stroke: var(--color-secondary-button);
      :focus {
        box-shadow: none !important;
        color: var(--color-secondary-button);
        background-color: var(--background-secondary-button);
        border-color: var(--background-secondary-button);
        stroke: var(--color-secondary-button);
        outline: var(--outline-button);
      }
      :hover {
        color: var(--color-secondary-button-hover);
        background-color: var(--background-secondary-button-hover);
        border-color: var(--background-secondary-button-hover);
        stroke: var(--color-secondary-button-hover);
      }
      :active {
        box-shadow: none !important;
        color: var(--color-secondary-button-active);
        background-color: var(--background-secondary-button-active);
        border-color: var(--background-secondary-button-active);
        stroke: var(--color-secondary-button-active);
      }
      :disabled {
        color: var(--color-secondary-button-disabled);
        background-color: var(--background-secondary-button-disabled);
        border-color: var(--background-secondary-button-disabled);
      }
    `};
`;

const Button = ({ size = 'medium', secondary, children, disabled, className, type, ...restProps }: ButtonProps) => (
  <BaseButton
    size={size}
    issecondary={secondary ? 1 : 0}
    disabled={disabled}
    className={className}
    type={type}
    {...restProps}
  >
    {children}
  </BaseButton>
);

export default Button;
